module.exports = __webpack_public_path__ + "static/media/vintage13.d4476e9c.png";